<template>
    <div class="teste">
        my-stuff
    </div>
</template>


<script>

export default {
    name: "dv5-my-stuff",
    props: ["view"],
    data() {
        return {
        };
    },

    mounted() {
    },
    created() {
    },

    methods: {
    },

    filters: {
    },

    computed: {
    },

    watch: {
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.teste {
    width: 50px;
    height: 50px;
    background-color: blue;
}

</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/my-stuff/index.vue